/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components

// Material Dashboard 2 PRO React components

// Material Dashboard 2 PRO React imageExample components

// WelcomeLeave page components
// Images
import {useMemo} from "react";
import {Skeleton} from "@mui/material";
import {faSpinnerThird} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faTimes, faTrash} from "@fortawesome/pro-solid-svg-icons";
import MDButton from "../../../../../components/MDButton";
import apiErrorMessages from "../../../../../apiMessages";
import ReloadTable from "../../../../../components/Table/ReloadTable";
import {useSelector} from "react-redux";
import {useDeleteModuleDataMutation} from "../../../../../store/modules/module-api";

const module = "word-blacklist";

export function WordBlacklistTable({ botId, guildId }) {
  const [deleteModuleData, { isLoading: deleteModuleDataIsLoading }] = useDeleteModuleDataMutation({});

  const expertMode = useSelector((state) => state.ui.expertMode);

  const deleteDataEvent = (id) => {
    deleteModuleData({ botId, guildId, module, id, isModule: false }).then(({ data, error }) => {
      apiErrorMessages.showMessage({
        type: "WordBlacklist",
        title: data ? "deleted" : error?.data?.error || error,
      });
    });
  };

  const tableColumns = useMemo(
    () =>
      [
        {
          Header: "Zeichenfolge",
          accessor: "wordOrRegex",
        },
        {
          Header: "Ist Regex?",
          accessor: "isRegex",
        },
        {
          Header: "Actions",
          accessor: "actions",
          disableSort: true,
          width: "0%",
        },
      ].filter((x) => x),
    []
  );

  const tableRows = useMemo(
    () => (row) => ({
      wordOrRegex: row.word,
      isRegex: row.regex ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faTimes} />,
      expiresAt: row.expiresAt ? new Date(row.expiresAt).toLocaleString() : "Nicht gesetzt",
      actions: (
        <MDButton
          variant="contained"
          iconOnly
          disabled={deleteModuleDataIsLoading}
          color="primary"
          onClick={() => deleteDataEvent(row.id)}
        >
          {deleteModuleDataIsLoading ? (
            <FontAwesomeIcon icon={faSpinnerThird} size="lg" spin />
          ) : (
            <FontAwesomeIcon icon={faTrash} size="lg" />
          )}
        </MDButton>
      ),
    }),
    [deleteModuleDataIsLoading]
  );

  return (
    <ReloadTable
      path={{
        botId,
        guildId,
        module,
      }}
      loaded
      rowsLoad={() => ({
        roleId: <Skeleton width={100} animation="wave" />,
        roleName: <Skeleton width={100} animation="wave" />,
        actions: <Skeleton width={100} animation="wave" />,
      })}
      columns={tableColumns}
      rows={tableRows}
      canSearch
      showTotalEntries
    />
  );
}
